import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <div className="top-bar">
          <div className="user-info">
            <span className="user-icon">👤</span>
            <span className="user-email">{user?.email || 'admin@roameez.com'}</span>
          </div>
        </div>

        <div className="page-container">
          <div className="page-header">
            <div>
              <h1 className="page-title">Dashboard</h1>
              <div className="breadcrumb">
                <span>Dashboard</span>
              </div>
            </div>
          </div>

          <div className="welcome-container">
            <div className="welcome-card">
              <h2>Welcome to Roameez Admin Panel</h2>
              <p>Hello, <strong>{user?.name || 'Admin'}</strong>!</p>
              <p>Use the sidebar to navigate through the admin panel.</p>
              <div className="welcome-links">
                <a href="/users" className="welcome-link">Manage Users</a>
                <a href="/trips" className="welcome-link">Manage Trips</a>
                <a href="/support" className="welcome-link">Support</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
